<template>
  <div ref="carousel"
       class="relative z-10 inline-flex mt-6 space-x-6 whitespace-nowrap pb-[40px] scrollable-content overflow-scroll"
       :style="{ width: scrollContainerWidth}">
    <Card v-for="organizer in organizers" :organizer="organizer"></Card>
  </div>
  <div class="flex flex-row justify-evenly mx-[20%] mb-[50px]">
    <div v-for="index in 6" :key="index" class="w-[16px] h-[16px] rounded-full"
         :class="[index === 1 ? 'bg-[#585858]': 'bg-[#ADADAD]']"
    ></div>
  </div>
</template>

<script>
import {computed} from "vue";
import {useWindowSize} from "@vueuse/core";
import Card from "./Card.vue";

export default {
  components: {Card},
  props: {
    organizers: {
      type: Array,
      default: []
    }
  },

  setup() {

    const { width } = useWindowSize();

    const scrollContainerWidth = computed(() => {
        return width.value - 37 + 'px'
    })

    return {
      scrollContainerWidth
    }
  }
}
</script>

<style>

.scrollable-content::-webkit-scrollbar {
  display: none;
}
</style>
